import React, { Component } from 'react';

export default class NoMobileSupport extends React.Component {
    render() {
        return <div className="noMobileSupport">&nbsp;&nbsp;</div>;
    }
}